export enum Actions {
  Add = 'add',
  Edit = 'edit',
  Delete = 'delete'
}

export enum ButtonText {
  Save = 'Save',
  SaveAndNext = 'Save and add another'
}

export type DialogBtnProps = {
  onClick: () => void;
};

export interface LocationListInfo {
  id: number;
  name: string;
  street_building: string;
  city: string;
  zip_code: number;
  status: string;
}

export enum TestID {
  addButton = 'add_location_btn',
  addButtonCTA = 'cta_add_button'
}
